import memoizee from 'memoizee';
import { dateUTCToYYYYMMDD } from '../utils/DateUtils';
var getServicePointMap = memoizee(function (servicePoints) {
    var map = {};
    servicePoints.forEach(function (sp) {
        map[sp.id] = sp;
    });
    return map;
});
var DataRepository = /** @class */ (function () {
    function DataRepository(calendars, servicePoints, mutators) {
        this.calendarsLoaded = calendars !== undefined;
        this.calendars = calendars !== null && calendars !== void 0 ? calendars : [];
        this.servicePointsLoaded = servicePoints !== undefined;
        this.servicePoints = servicePoints !== null && servicePoints !== void 0 ? servicePoints : [];
        this.mutators = mutators;
    }
    /** If enough data has loaded for the app to render */
    DataRepository.prototype.isLoaded = function () {
        return this.areServicePointsLoaded() && this.areCalendarsLoaded();
    };
    /** If service points have been loaded */
    DataRepository.prototype.areServicePointsLoaded = function () {
        return this.servicePointsLoaded;
    };
    /** Get all service points */
    DataRepository.prototype.getServicePoints = function () {
        if (!this.areServicePointsLoaded()) {
            return [];
        }
        return this.servicePoints.map(function (dto) { return ({
            id: dto.id,
            name: dto.name,
            inactive: false,
        }); });
    };
    /** Get an array of service points corresponding to the provided ids */
    DataRepository.prototype.getServicePointsFromIds = function (ids) {
        var map = getServicePointMap(this.getServicePoints());
        return ids
            .map(function (id) { return map[id]; })
            .filter(function (sp) { return sp !== undefined; });
    };
    /** Get the service point, or undefined, corresponding to the provided id */
    DataRepository.prototype.getServicePointFromId = function (id) {
        if (id === undefined)
            return undefined;
        var map = getServicePointMap(this.getServicePoints());
        return map[id];
    };
    /** Get an array of names corresponding to provided IDs.  Unknown IDs will be excluded */
    DataRepository.prototype.getServicePointNamesFromIds = function (ids) {
        return this.getServicePointsFromIds(ids).map(function (sp) { return sp.name; });
    };
    /** If the calendars have finished loading */
    DataRepository.prototype.areCalendarsLoaded = function () {
        return this.calendarsLoaded;
    };
    /** Gets all the calendars, as an array */
    DataRepository.prototype.getCalendars = function () {
        if (!this.areCalendarsLoaded()) {
            return [];
        }
        return this.calendars;
    };
    /** Get a calendar by ID */
    DataRepository.prototype.getCalendar = function (id) {
        if (id === undefined || id === null)
            return undefined;
        return this.getCalendars().filter(function (calendar) { return calendar.id === id; })[0];
    };
    /** Create a new calendar */
    DataRepository.prototype.createCalendar = function (calendar) {
        return this.mutators.create(calendar);
    };
    /** Update a new calendar */
    DataRepository.prototype.updateCalendar = function (newCalendar) {
        return this.mutators.update(newCalendar);
    };
    /** Delete a given calendar */
    DataRepository.prototype.deleteCalendar = function (calendar) {
        return this.mutators.delete([calendar]);
    };
    /** Delete a list of given calendars.  Sends a single request with comma-delimited IDs */
    DataRepository.prototype.deleteCalendars = function (calendars) {
        return this.mutators.delete(calendars);
    };
    /**
     * Get dates between a given range.  Service point will be provided by the
     * current route
     */
    DataRepository.prototype.getDailyOpeningInfo = function (servicePointId, startDate, endDate) {
        return this.mutators.dates({
            servicePointId: servicePointId,
            startDate: dateUTCToYYYYMMDD(startDate),
            endDate: dateUTCToYYYYMMDD(endDate),
        });
    };
    return DataRepository;
}());
export default DataRepository;
